export enum NotificationAction {
  NEW_ARTICLE = 'new_article',
  NEW_INVOICE = 'new_invoice',
  INVOICE_REPORTED = 'invoice_reported',
  INVOICE_DECLINED = 'invoice_declined',
}
